import React from 'react';
import * as Switch from '@radix-ui/react-switch';

// --------------------------------------------------------
// Switch Root
/**
 *  Contains all the parts of a switch. An `input` will also render when used within a form to ensure events propagate correctly.
 *
 * [data-state]: "checked" | "unchecked"
 * [data-disabled]: Present when disabled
 *
 */
const Root = ({
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Switch.Root, props);
};
Root.displayName = "Root"; // --------------------------------------------------------
// Switch Thumb
/**
 *  The thumb that is used to visually indicate whether the switch is on or off.
 *
 * [data-state]: "checked" | "unchecked"
 * [data-disabled]: Present when disabled
 *
 */
const Thumb = ({
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Switch.Thumb, props);
};
Thumb.displayName = "Thumb";
Thumb.displayName = 'Thumb';
Root.displayName = 'Switch';
export default Object.assign(Root, {
  Thumb
});